/**
 * 项目首页
 */
import React, { useEffect, useState } from 'react';
import styles from './brainHealthStudio.module.scss';
import brainHealthStudio0 from '../../static/images_doctor/brainHealthStudio0.png';
import brainHealthStudio1 from '../../static/images_doctor/brainHealthStudio1.png';
import brainHealthStudio2 from '../../static/images_doctor/brainHealthStudio2.png';
import brainHealthStudio3 from '../../static/images_doctor/brainHealthStudio3.png';

function BrainHealthStudio(props: any) {

    useEffect(() => {
        //设置网页title
        document.title = '工具介绍';
    }, [])

    return (
        <div className={styles.brainHealthStudioContent}>
            <img src={brainHealthStudio0} alt='' width={'100%'} style={{ minHeight: '322px' }} />
            <img src={brainHealthStudio1} alt='' width={'100%'} style={{ minHeight: '548.5px' }}  />
            <img src={brainHealthStudio2} alt='' width={'100%'} style={{ minHeight: '678px' }} />
            <img src={brainHealthStudio3} alt='' width={'100%'} style={{ minHeight: '624.5px' }} />
        </div>
    )
}

export default BrainHealthStudio;